import React from 'react';
import { Minus, Plus, Trash2 } from 'lucide-react';
import { FreeShippingProgress } from './shipping';

// CartScreen (carrinho) do cardápio público. Extraído VERBATIM de PublicMenu.js
// (Fase 2 refactor). Mantido como FUNÇÃO (chamado inline como {CartScreen({...})},
// não como componente JSX) para preservar o comportamento de render inline do pai.
const CartScreen = ({ cart, setCurrentScreen, updateCartItemQuantity, getCartTotal, deliveryConfig, deliveryType, calculatedFee, selectedZone, checkoutScrollTopRef, navigateToScreen }) => (
    <div className="pt-20 pb-32 px-4 h-screen overflow-y-auto cart-scroll" style={{ WebkitOverflowScrolling: 'touch' }}>
      {cart.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-600 text-lg">Seu carrinho está vazio</p>
          <button 
            onClick={() => setCurrentScreen('home')}
            className="mt-4 bg-primary hover:bg-primary-hover text-white px-6 py-3 rounded-lg transition-colors"
          >
            Ver Cardápio
          </button>
        </div>
      ) : (
        <>
          <div className="space-y-4 mb-6">
            {cart.map(item => (
              <div key={item.id} className="bg-white rounded-lg shadow-sm p-4">
                <div className="flex items-start space-x-4">
                  {item.product.image_url && (
                    <img 
                      src={item.product.image_url} 
                      alt={item.product.name}
                      className="w-16 h-16 rounded-lg object-cover"
                      onError={(e) => {
                        e.target.src = "https://res.cloudinary.com/df9ady2jx/image/upload/v1766408761/pedi-facil/default-product-image.jpg";
                      }}
                    />
                  )}
                  <div className="flex-1">
                    <p className="font-medium">{item.quantity}x {item.product.name}</p>
                    {item.additionals.map(add => (
                      add.quantity > 0 && (
                        <p key={add.id} className="text-sm text-gray-600">
                          {add.quantity}x {add.name}
                        </p>
                      )
                    ))}
                    {item.notes && (
                      <p className="text-sm text-gray-600 italic mt-1">
                        📌 Obs: {item.notes}
                      </p>
                    )}
                    <div className="flex items-center justify-between mt-2">
                      <div className="flex items-center space-x-3">
                        <button 
                          onClick={() => updateCartItemQuantity(item.id, item.quantity - 1)}
                          className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center"
                        >
                          <Minus size={16} />
                        </button>
                        <span>{item.quantity}</span>
                        <button 
                          onClick={() => updateCartItemQuantity(item.id, item.quantity + 1)}
                          className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center"
                        >
                          <Plus size={16} />
                        </button>
                        <button 
                          onClick={() => updateCartItemQuantity(item.id, 0)}
                          className="ml-2 text-red-500"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                      <p className="font-bold">R$ {item.totalPrice.toFixed(2)}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button 
            onClick={() => setCurrentScreen('home')}
            className="w-full border border-primary text-primary py-3 rounded-lg mb-4 transition-all duration-300 hover:bg-primary-light"
          >
            Adicionar mais produtos
          </button>

          <FreeShippingProgress
            subtotal={getCartTotal()}
            shippingPromo={deliveryConfig?.shipping_promo}
            deliveryType={deliveryType}
            baseFee={deliveryType === 'delivery' ? (deliveryConfig?.mode === 'radius' ? (calculatedFee?.original_fee ?? calculatedFee?.fee ?? 0) : (selectedZone?.fee ?? 0)) : 0}
          />

          <div className="fixed bottom-4 left-4 right-4 z-50">
            <button 
              onClick={() => { checkoutScrollTopRef.current = 0; navigateToScreen('checkout'); }}
              className="w-full bg-primary hover:bg-primary-hover text-white py-4 rounded-lg font-medium animate-slow-pulse hover:animate-none hover:scale-105 transition-all duration-300"
            >
              Avançar • R$ {getCartTotal().toFixed(2)}
            </button>
          </div>
        </>
      )}
    </div>
);

export default CartScreen;
